import React, { useEffect, useState } from 'react'
import { Checkbox, Divider, Space } from 'antd'
import useQueryParam from '../../../../../hooks/useQueryParam'
import useQueryParamSetter from '../../../../../hooks/useQueryParamSetter'
import { STUDENT_FEEDBACK_EXACT_MATCH_PARAM, STUDENT_FEEDBACK_PARAM } from '../../../../../constants/query-params'
import { errorColor, successColor } from '../../../../../constants/styles'
import { CommentOutlined, DislikeOutlined, LikeOutlined } from '@ant-design/icons'

const options = [
    { label: 'Liked', value: 'liked', icon: <LikeOutlined style={{ color: successColor }} /> },
    { label: 'Disliked', value: 'disliked', icon: <DislikeOutlined style={{ color: errorColor }} /> },
    { label: 'Commented', value: 'commented', icon: <CommentOutlined /> },
]

const StudentFeedbackFilters = () => {
    const queryFilters = useQueryParam(STUDENT_FEEDBACK_PARAM)
    const queryExactMatch = useQueryParam(STUDENT_FEEDBACK_EXACT_MATCH_PARAM)
    const setQueryParam = useQueryParamSetter()

    const [checkedValues, setCheckedValues] = useState(queryFilters ? queryFilters.split(',') : [])
    const [exactMatch, setExactMatch] = useState(queryExactMatch === 'true')

    const onChangeFeedbackFilters = newValues => {
        setCheckedValues(newValues)
        setQueryParam({ [STUDENT_FEEDBACK_PARAM]: newValues.join(',') })
    }

    const onChangeExactMatch = e => {
        setExactMatch(e.target.checked)
        setQueryParam({ [STUDENT_FEEDBACK_EXACT_MATCH_PARAM]: e.target.checked ? 'true' : 'false' })
    }

    useEffect(() => {
        if (queryFilters && queryFilters.split(',').sort().join(',') !== checkedValues.sort().join(',')) {
            setCheckedValues(queryFilters.split(','))
        }
        if ((queryExactMatch === 'true') !== exactMatch) {
            setExactMatch(queryExactMatch === 'true')
        }
    }, [queryFilters, queryExactMatch])

    return (
        <Space direction='vertical'>
            <Checkbox checked={exactMatch} onChange={onChangeExactMatch}>
                Exact Match
            </Checkbox>
            <Divider style={{ margin: '8px 0' }} />
            <Checkbox.Group value={checkedValues} onChange={onChangeFeedbackFilters}>
                <Space direction='vertical'>
                    {options.map(({ label, value, icon }) => (
                        <Checkbox key={value} value={value}>
                            <Space size={8}>
                                {icon}
                                {label}
                            </Space>
                        </Checkbox>
                    ))}
                </Space>
            </Checkbox.Group>
        </Space>
    )
}

export default StudentFeedbackFilters
